import styled from "styled-components";

const Button = styled.div`
	cursor: pointer;
`;

export default Button;
